export const iconFontAwesomeConnectivityCloud = (
	<i className="fa-solid fa-cloud"></i>
);
